import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';
import { meduCanDeactivateGuard } from './guards/medu-can-deactivate.guard';

export const routes: Routes = [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'inicio'
    },
    { path: 'inicio', 
      loadComponent: () => import('./pages/home/home.component').then(module => module.HomeComponent),
      canActivate: [authGuard]
    },
    { path: 'masterclasses',
      canActivate: [authGuard],
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      data: { 
        tipo: 'masterclasses',
        columnas: 2,
        tipoCard: 'tipo3',
        portada: 'portada_Masterclasses.jpg',
      }
    },
    { path: 'sesiones', 
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      canActivate: [authGuard],
      data: { 
        tipo: 'sesiones',
        tipoListaReproduccion: 'sesiones',
        columnas: 3,
        tipoCard: 'tipo2',
        portada: 'portada_Sesiones.jpg'
      }
    },
    { path: 'capsulas', 
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      canActivate: [authGuard],
      data: { 
        tipo: 'capsulas',
        columnas: 4,
        tipoCard: 'tipo4',
        portada: 'portada_Capsulas.jpg',
        blockedRoles: ['RepresentanteLatam', 'MedicoLatam']
      }
    },
    { path: 'casos-clinicos',
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      canActivate: [authGuard],
      data: {
        tipo: 'casos-clinicos',
        fuente: 'casos-clinicos',
        label: 'Casos Clínicos',
        columnas: 2,
        tipoCard: 'tipo3',
        portada: 'portada_Capsulas.jpg',
        blockedRoles: ['RepresentanteLatam', 'MedicoLatam']
      }
    },
    { path: 'podcasts', 
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      canActivate: [authGuard],
      data: { 
        tipo: 'podcasts',
        columnas: 2,
        tipoCard: 'tipo7',
        portada: 'portada_Podcast.jpg'
      }
    },
    { path: 'shorts',
      loadComponent: () => import('./pages/listado-contenido/listado-contenido.component').then(module => module.ListadoContenidoComponent),
      canActivate: [authGuard],
      data: {
        tipo: 'shorts',
        tipoCard: 'tipo12',
        portada: 'portada_Capsulas.jpg'
      }
    },
    { path: 'shorts/:idShort',
      loadComponent: () => import('./pages/public-short/public-short.component').then(module => module.PublicShortComponent)
    },
    { path: 'terminos-y-condiciones', 
      loadComponent: () => import('./pages/legal-notice/legal-notice.component').then(module => module.LegalNoticeComponent),
      data: { 
        tipo: 'terminos'
      }
    },
    { path: 'politica-de-privacidad', 
      loadComponent: () => import('./pages/legal-notice/legal-notice.component').then(module => module.LegalNoticeComponent),
      data: { 
        tipo: 'politica'
      }
    },
    { path: 'mi-aprendizaje', 
      loadComponent: () => import('./pages/mi-aprendizaje/mi-aprendizaje.component').then(module => module.MiAprendizajeComponent),
      canActivate: [authGuard],
    },
    { path: 'mi-aprendizaje/:tab', 
      loadComponent: () => import('./pages/mi-aprendizaje/mi-aprendizaje.component').then(module => module.MiAprendizajeComponent),
      canActivate: [authGuard],
    },
    { path: 'masterclass/teaser/:idMasterclass', 
      // Los enlaces antiguos reutilizan la carga de la masterclass con su alias de parámetro.
      loadComponent: () => import('./pages/detalle-contenido/detalle-contenido.component').then(module => module.DetalleContenidoComponent),
      canActivate: [authGuard],
      data: { tipoContenido: 'masterclass' },
    },
    { path: 'mi-perfil', 
      loadComponent: () => import('./pages/home/home.component').then(module => module.HomeComponent),
      canActivate: [authGuard],
    },
    { path: 'login', 
      loadComponent: () => import('./pages/login/login.component').then(module => module.LoginComponent),
    },
    { path: 'busqueda', 
      loadComponent: () => import('./pages/busqueda/busqueda.component').then(module => module.BusquedaComponent),
      canActivate: [authGuard]
    },
    { path: 'alta-usuarios', 
      redirectTo: 'inicio',
      pathMatch: 'full'
    },
    // { path: 'login', 
    //   loadComponent: () => import('./pages/login/login.component').then(module => module.LoginComponent)
    // },
    { path: 'bienvenida', 
      loadComponent: () => import('./pages/portada/portada.component').then(module => module.PortadaComponent)
    },
    { path: 'error', 
      loadComponent: () => import('./pages/error-page/error-page.component').then(module => module.ErrorPageComponent)
    },
    { path: 'usuario', 
      canActivate: [authGuard],
      loadComponent: () => import('./pages/detalle-usuario/detalle-usuario.component').then(module => module.DetalleUsuarioComponent)
    },
    { path: 'contenido/lista-de-reproduccion/:tipoContenido/:idContenido',
      loadComponent: () => import('./pages/detalle-contenido/detalle-contenido.component').then(module => module.DetalleContenidoComponent),
      canDeactivate: [meduCanDeactivateGuard],
      // canActivate: [authGuard]
    },
    { path: 'contenido/:tipoContenido/:idContenido',
      loadComponent: () => import('./pages/detalle-contenido/detalle-contenido.component').then(module => module.DetalleContenidoComponent),
      canDeactivate: [meduCanDeactivateGuard],
      // canActivate: [authGuard]
    },
    { path: 'contenido', 
      loadComponent: () => import('./pages/detalle-contenido/detalle-contenido.component').then(module => module.DetalleContenidoComponent),
      canDeactivate: [meduCanDeactivateGuard]
    },
    { path: 'webinar/:idWebinar',
      // canActivate: [authGuard],
      loadComponent: () => import('./pages/webinar/webinar.component').then(module => module.WebinarComponent)
    },
    { path: 'examen', 
      loadComponent: () => import('./pages/detalle-examen/detalle-examen.component').then(module => module.DetalleExamenComponent)
    },
    {
        path: 'dummy',
        loadComponent: () => import('./pages/dummy/dummy.component').then(module => module.DummyComponent)
    },
    {
        path: '**',
        redirectTo: 'inicio'
    },
    
];
